import { render, staticRenderFns } from "./SearchCollapse.vue?vue&type=template&id=25592924&scoped=true&"
import script from "./SearchCollapse.vue?vue&type=script&lang=js&"
export * from "./SearchCollapse.vue?vue&type=script&lang=js&"
import style0 from "./SearchCollapse.vue?vue&type=style&index=0&id=25592924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25592924",
  null
  
)

export default component.exports